export const getPaddingLeft = (download: boolean, yAxisLabel?: string | undefined) =>
  download && !yAxisLabel ? 40 : 5;
